module.exports = __webpack_public_path__ + "static/media/intelij_big.aa14f9c8.png";